import { combineReducers } from 'redux';
import currentImageReducer from './currentImageReducer'
import currentBackgroundReducer from './currentBackgroundReducer'
import previousSubjectReducer from './previousSubjectReducer'

export default combineReducers({
    currentImage: currentImageReducer,
    currentBackground: currentBackgroundReducer,
    previousSubject: previousSubjectReducer
});